export { default } from './Divider';